// extracted by mini-css-extract-plugin
export default {"content-wrapper":"BrokerUserDetails_content-wrapper__yHGU6","content":"BrokerUserDetails_content__LXk7R","no-img":"BrokerUserDetails_no-img__cXCxc"};